import {Flash, FormControl, Radio, RadioGroup, Stack, Textarea} from '@primer/react'
import styles from './BaseSharedDismissalForm.module.css'

export type SharedDismissalOption = {value: string; label: string; description: string}

export function validateComment({
  dismissalComment,
  commentRequired,
}: {
  dismissalComment: string
  commentRequired: boolean
}) {
  return commentRequired ? Boolean(dismissalComment.trim()) : true
}

export function validateReasonSelected({reason}: {reason: string}) {
  return Boolean(reason)
}

export interface BaseSharedDismissalFormProps {
  error: Error | null
  disabled?: boolean
  commentRequired: boolean
  dismissalOptions: SharedDismissalOption[]
  reasonSelected: string
  onReasonChange: (resolution: string) => void
  reasonValidationError?: string | null
  dismissalComment: string
  onDismissalCommentChange: (dismissalComment: string) => void
  commentValidationError?: string | null
  radioGroupName: string
}

export function BaseSharedDismissalForm({
  error,
  disabled,
  commentRequired,
  dismissalOptions,
  reasonSelected,
  onReasonChange,
  reasonValidationError,
  dismissalComment,
  onDismissalCommentChange,
  commentValidationError,
  radioGroupName,
}: BaseSharedDismissalFormProps) {
  const handleRadioGroupChange = (value: string | null) => {
    onReasonChange(value ?? '')
  }

  return (
    <Stack gap="normal">
      {error && <Flash variant="danger">{error.message}</Flash>}
      <RadioGroup name={radioGroupName} onChange={handleRadioGroupChange} disabled={disabled}>
        <RadioGroup.Label visuallyHidden>Dismissal reason</RadioGroup.Label>
        {dismissalOptions.map(option => (
          <FormControl key={option.value}>
            <Radio checked={reasonSelected === option.value} value={option.value} />
            <FormControl.Label>{option.label}</FormControl.Label>
            <FormControl.Caption>{option.description}</FormControl.Caption>
          </FormControl>
        ))}
        {reasonValidationError && (
          <RadioGroup.Validation variant="error">{reasonValidationError}</RadioGroup.Validation>
        )}
      </RadioGroup>
      <div>
        <FormControl disabled={disabled}>
          <FormControl.Label required={commentRequired}>Comment</FormControl.Label>
          <Textarea
            placeholder="Add a comment"
            value={dismissalComment}
            rows={5}
            maxLength={280}
            name="dismissal_comment"
            onChange={e => onDismissalCommentChange(e.target.value)}
            className={styles.dismissalCommentTextarea}
          />
          {commentValidationError && (
            <FormControl.Validation variant="error">{commentValidationError}</FormControl.Validation>
          )}
        </FormControl>
      </div>
    </Stack>
  )
}
